import { loadScript } from "./utils";

let chart = {
    loadScript: async function (dataLabels) {
        //console.log('[Chart] loadScript', dataLabels);

        if (dataLabels) {
            await loadScript('https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.7.1/chart.min.js');
            return await loadScript('https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.0.0');

        }
        else {
            return await loadScript('https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.7.1/chart.min.js');
        }

    },
    current: {},
    currentMap: new Map(),
    setup: function (id, config) {
        var ctx = document.getElementById(id).getContext('2d');
        //console.log("chart:", config);

        var legendElementId = 'chart-legend' + config.chartId;

        var hoverFn = function (e, legendItem, legend) {
            var list = document.getElementById(legendElementId);

            var listItems = Array.from(list.children);
           
            if (legendItem.length === 1) {

                list.classList.add("active");
                listItems.forEach((li, i) => {
                    if (legendItem[0].index === i) {
                        li.classList.add("legend-active");
                    }
                    else {
                        li.classList.remove("legend-active");
                    }
                });
            }
            else {
                //console.log("[chart] hover no item ");
                list.classList.remove("active");
                listItems.forEach((li, i) => {

                    li.classList.remove("legend-active");

                });
            }
        };

        if (config.type === 'line' || config.type === 'bar') {  
            hoverFn = function (e, data, legend) {
                //console.log("linechart interact @ ", e, data, legend, legendElementId);   
                var list = document.getElementById(legendElementId);
                var listItems = Array.from(list.children);
                if (data.length > 0) {
                    //console.log("ok", data.length);
                    var selectedDs = data[0].datasetIndex;
                    //console.log("chart click  le", selectedItem);
         
                    list.classList.add("active");

                    listItems.forEach((li, i) => {
                        if (selectedDs === i) {
                            li.classList.add("legend-active");
                        }
                        else {
                            li.classList.remove("legend-active");
                        }
                    });             
                }
                else {
                    //console.log("[chart] hover no item ");
                    list.classList.remove("active");
                    listItems.forEach((li, i) => {

                        li.classList.remove("legend-active");

                    });
                }
            };
        }

        var plugins = [];

        if (config.datalabels) {
            plugins = [ChartDataLabels];
        }

        var hitliteFn = function (value, ctx) {
            //console.log('Qhilite2', ctx);
            return config.data.hiliteText;
        }

        var hitliteDisplayFn = function (ctx) {
            //console.log('Qhilite display', ctx, config.data);
            if (config.data.hiliteIndex < 0) { return false; }
            else {
                return ctx.datasetIndex == config.data.hiliteSeriesIndex && ctx.dataIndex == config.data.hiliteIndex;
            }
        }

        var defaultDisplayFn = function (ctx) {
            //console.log('default display', ctx, config.defaultDatalabels);
            if (config.defaultDatalabels) { return 'auto'; }
            else {
                return false;
            }

        }

        var options = {
            type: config.type,
            data: config.data,
            plugins: plugins,
            options: {
                locale: 'sv-SE',
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                },
                interaction: config.interaction,
                scales: config.scales,
                responsive: true,
                layout: config.layout,

                onClick: function (e, legendItem, legend) {
                },
              onHover: hoverFn,
             
                plugins: {
                    datalabels: {
                        display: function (ctx) {
                            //console.log('display ctx', ctx, ctx.dataset.data[ctx.dataIndex]);
                            return false;
                        },
                        formatter: function (value, ctx) {
                            return value.toLocaleString('sv-SE');
                        }
                    },             
                    tooltip: {
                        enabled: (config.type === 'line' || config.type === 'bar') ? true : false,
                        intersect: config.type === 'line' ? false : true,
                        mode: 'nearest',
                        yAlign: 'center',
                        padding: 13,
                        backgroundColor: '#ffffff',
                        borderColor: '#cccccc',
                        bodyColor: '#000000',
                        shadow: true,
                        shadowcolor: '#000000',
                        boxShadow: '0px 1px 8px #22222229',
                        shadowOffsetX: 0,
                        shadowOffsetY: 1,
                        shadowBlur: 8,
                        shadowColor: '#22222229',
                        borderWidth: 1,
                        titleColor: '#222222',
                        cornerRadius: 0,
                        pointerStyle: 'circular',
                        usePointStyle: true,          
                        titleFont: {
                            family : "Telge Sans"
                        },
                        bodyFont: {
                            family : "Telge Sans"
                        }
                    },
                    legend: { display: false },
                    title: config.title
                },
                legend: {
                    display: false,
                    position: 'top',
                    onClick: function (e) {
                        //console.log("legend  click  @ x: " + e);
                    }
                }
            }
        }

        if (options.data.datasets) {
            
            options.data.datasets.forEach((dx, i) => {
                //console.log('adding formatter:', dx);
                if (dx.datalabels?.labels?.hilite) {

                    dx.datalabels.labels.hilite.formatter = hitliteFn;
                    dx.datalabels.labels.hilite.display = hitliteDisplayFn;
                }
                if (dx.datalabels?.labels?.default) {
                    dx.datalabels.labels.default.display = defaultDisplayFn;
                }
            });
        }

        var myChart = new Chart(ctx, options);

        chart.currentMap.set(config.chartId, myChart)
    },
    onClick: (evt, item) => {
        //console.log('[CHART] clicked')
        current.update()
        item[0]._model.outerRadius += 10
    },
    clearLegendClasses: (legendElementId) => {

        //console.log("[Chart] Clear legend classes");
        var list = document.getElementById(legendElementId);

        var listItems = Array.from(list.children);
        list.classList.remove("active");
        listItems.forEach((li, i) => {

            li.classList.remove("legend-active");

        });
    },
    highlightItem: (evt, index, chartId) => {

        //console.log("highlightItem", index, chartId);

        var currentChart = chart.currentMap.get(chartId);

        //console.log("highlightItem", currentChart);

        if (index < 0) {
            currentChart.setActiveElements([]);
        }
        else {
            currentChart.setActiveElements([
                { datasetIndex: 0, index: index },
            ]);
        }

        currentChart.render();
    },
    highlightLine: (evt, ds, count, chartId) => {
        //console.log("highlightLine", ds, count);
        var currentChart = chart.currentMap.get(chartId);
        if (ds < 0) {
            currentChart.setActiveElements([]);
        }
        else {
            currentChart.setActiveElements([
                { datasetIndex: ds, index: 0 }
            ]);
        }



        currentChart.render();
    },
    highlightBar: (evt, ds, count, chartId) => {
        //console.log("highlightBar", ds, count);

        var activeElements = [];
        for (var i = 0; i < count; i++) {
            activeElements.push({ datasetIndex: ds, index: i })
        }
        var currentChart = chart.currentMap.get(chartId);
        if (ds < 0) {
            currentChart.setActiveElements([]);
        }
        else {
            currentChart.setActiveElements(activeElements);
        }



        currentChart.render();
    }
};

export { chart };